import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useLocation, withRouter } from 'react-router-dom'
import useHubspot from './useHubspot'

const Hubspot = (props) => {
  const { sendPageView } = useHubspot(props.portalId)
  const location = useLocation()

  useEffect(() => {
    sendPageView(location.pathname)
  }, [location, sendPageView])
  return null
}

Hubspot.propTypes = {
  portalId: PropTypes.string.isRequired
}
export default withRouter(Hubspot)
